import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { OrganizationTableItem } from 'types/organizations_table'

interface RenderDealWithAvatarProps {
  deal: OrganizationTableItem
  route: string
  sizes?: {
    height?: number
    width?: number
    py?: number
    px?: number
    padding?: number
    gap?: number
    fontSize?: number
  }
  renderIcon?: boolean
}
const RenderDealWithAvatar: FC<RenderDealWithAvatarProps> = ({ deal, route, sizes, renderIcon }) => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: renderIcon ? 'left' : 'space-between',
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        maxWidth: '100%',
        fontWeight: 'bold',
        cursor: 'pointer',
        padding: sizes?.padding ?? 0,
        py: sizes?.py ?? 0,
        px: sizes?.py ?? 0,
        gap: sizes?.gap ?? 1,
        '&:hover': {
          opacity: 0.7,
        },
      }}
      onClick={() => navigate(route)}
    >
      {renderIcon && (
        <AttachMoneyIcon sx={{ color: 'icon.deals', height: sizes?.height ?? 18, width: sizes?.width ?? 18 }} />
      )}
      {!renderIcon && (
        <Typography
          variant="subtitle2"
          color="textSecondary"
          sx={{ textAlign: 'left', fontSize: sizes?.fontSize ?? 13 }}
        >
          Deal
        </Typography>
      )}
      <Typography
        noWrap
        variant="body2"
        sx={{
          fontSize: sizes?.fontSize ?? 12,
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {deal?.name}
      </Typography>
    </Box>
  )
}

export default RenderDealWithAvatar
